/** Deploy environment derived from the browser hostname. Add new prod domains here. */
export type AppEnvironment = 'production' | 'staging' | 'development';

const HOSTNAME_MAP: Record<string, AppEnvironment> = {
  'lookout.rudderstack.com': 'production',
  'lookout.staging.rudderlabs.com': 'staging',
  'lookout.dev.rudderlabs.com': 'development',
  localhost: 'development',
};

export function resolveAppEnvironment(hostname: string): AppEnvironment {
  const normalized = hostname.toLowerCase();
  return HOSTNAME_MAP[normalized] ?? 'development';
}

export function isFrontendAnalyticsEnabled(hostname: string): boolean {
  return resolveAppEnvironment(hostname) === 'production';
}
